module.exports = __webpack_public_path__ + "img/icon-bzsz.37f2481b.png";